import apiClient from '../lib/apiClient';

export const getTicketsApi = (params = {}) =>
  apiClient('/tickets', { params });

// GET /tickets/:ticket_id  →  { ticket, replies }
export const getTicketByIdApi = (ticketId) =>
  apiClient(`/tickets/${ticketId}`);

// POST /tickets  body: { subject, description }  →  { message, ticket_id }
export const createTicketApi = ({ subject, description }) =>
  apiClient('/tickets', { method: 'POST', body: { subject, description } });

// POST /tickets/:ticket_id/reply  body: { message }  →  { message, reply_id }
export const replyToTicketApi = ({ ticketId, message }) =>
  apiClient(`/tickets/${ticketId}/reply`, { method: 'POST', body: { message } });

// PUT /tickets/:ticket_id/close  →  { message: "Ticket closed" }
export const closeTicketApi = (ticketId) =>
  apiClient(`/tickets/${ticketId}/close`, { method: 'PUT' });
